(function () {
    'use strict';

    angular.module("imApp").factory("stockCountService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 953,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 954,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
